import Axios from 'axios'
import Vue from 'vue'
import Snackbar from 'Helpers/snackbar/index'

function errorNotify(msg) {
  Snackbar.error(msg)
}

const state = {}

const getters = {}

const actions = {
  deleteExportFormat(context, payload) {
    return new Promise((resolve, reject) => {
      Axios.delete(context.getters.apiExportFormatInstanceUrl, {
        data: {
          id: payload.data.id,
          organization_id: context.getters.getOrganizationID,
        },
        organization_id: context.getters.getOrganizationID,
        headers: { Authorization: context.getters.getAuthToken },
      })
        .then(function (response) {
          if ('error' in response.data) {
            errorNotify(response.data.error)
          } else {
            resolve(response)
          }
        })
        .catch(function (error) {
          errorNotify(error.message)
        })
    })
  },
  addExportFormat(context, payload) {
    return new Promise((resolve, reject) => {
      Axios.put(
        context.getters.apiExportFormatInstanceUrl,
        {
          name: payload.data.name,
          list: payload.data.list,
          organization_id: context.getters.getOrganizationID,
        },
        {
          headers: { Authorization: context.getters.getAuthToken },
        }
      )
        .then(function (response) {
          if ('error' in response.data) {
            errorNotify(response.data.error)
          } else {
            resolve(response)
          }
        })
        .catch(function (error) {
          errorNotify(error.message)
        })
    })
  },
  updateExportFormat(context, payload) {
    return new Promise((resolve, reject) => {
      Axios.post(
        context.getters.apiExportFormatInstanceUrl,
        {
          id: payload.data.id,
          name: payload.data.name,
          list: payload.data.list,
          organization_id: context.getters.getOrganizationID,
        },
        {
          headers: { Authorization: context.getters.getAuthToken },
        }
      )
        .then(function (response) {
          if ('error' in response.data) {
            errorNotify(response.data.error)
          } else {
            resolve(response)
          }
        })
        .catch(function (error) {
          errorNotify(error.message)
        })
    })
  },
}

export default {
  state,
  getters,
  actions,
}
